export default __webpack_public_path__ + "static/fans-c1fb447727110eb705af1b376a4ed2ab.png";